(() => {
  const mobileQuery = window.matchMedia('(max-width: 820px)');

  const initDiscovery = (root) => {
    if (!root || root.dataset.discoveryReady === 'true') return;
    const sheet = root.querySelector('[data-discovery-filter-sheet]');
    const openButton = root.querySelector('[data-discovery-filter-open]');
    const closeButton = root.querySelector('[data-discovery-filter-close]');
    const scrim = root.querySelector('[data-discovery-filter-scrim]');
    const form = root.querySelector('[data-discovery-filter-form]');
    const pending = root.querySelector('[data-discovery-pending]');
    let returnFocus = null;

    const focusable = () => sheet ? [...sheet.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter((element) => !element.hidden && element.getClientRects().length) : [];

    const applyDesktopState = () => {
      if (!sheet) return;
      sheet.hidden = false;
      sheet.inert = false;
      sheet.classList.remove('is-open');
      sheet.removeAttribute('aria-hidden');
      sheet.removeAttribute('aria-modal');
      sheet.setAttribute('role', 'region');
      if (scrim) scrim.hidden = true;
      if (openButton) openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('electro-filter-open');
    };

    const closeSheet = (restoreFocus = true) => {
      if (!sheet || !mobileQuery.matches) return;
      sheet.classList.remove('is-open');
      sheet.hidden = true;
      sheet.inert = true;
      sheet.setAttribute('aria-hidden', 'true');
      sheet.setAttribute('role', 'dialog');
      sheet.setAttribute('aria-modal', 'true');
      if (scrim) scrim.hidden = true;
      if (openButton) openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('electro-filter-open');
      if (restoreFocus && returnFocus) returnFocus.focus();
    };

    const openSheet = () => {
      if (!sheet || !mobileQuery.matches) return;
      returnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : openButton;
      sheet.hidden = false;
      sheet.inert = false;
      sheet.removeAttribute('aria-hidden');
      sheet.setAttribute('role', 'dialog');
      sheet.setAttribute('aria-modal', 'true');
      if (scrim) scrim.hidden = false;
      if (openButton) openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('electro-filter-open');
      requestAnimationFrame(() => {
        sheet.classList.add('is-open');
        (closeButton || focusable()[0] || sheet).focus();
      });
    };

    const syncMode = () => mobileQuery.matches ? closeSheet(false) : applyDesktopState();
    syncMode();
    mobileQuery.addEventListener?.('change', syncMode);
    openButton?.addEventListener('click', openSheet);
    closeButton?.addEventListener('click', () => closeSheet());
    scrim?.addEventListener('click', () => closeSheet());

    sheet?.addEventListener('keydown', (event) => {
      if (!mobileQuery.matches || sheet.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeSheet();
        return;
      }
      if (event.key !== 'Tab') return;
      const items = focusable();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    form?.querySelectorAll('[data-discovery-filter-input]').forEach((input) => {
      input.addEventListener('change', () => {
        input.dataset.filterTouched = 'true';
        if (pending) pending.hidden = false;
      });
    });
    form?.addEventListener('submit', () => {
      form.querySelectorAll('[data-default-availability]').forEach((input) => {
        if (input.dataset.filterTouched !== 'true') input.disabled = true;
      });
    });
    form?.querySelectorAll('[data-discovery-price-range]').forEach((range) => {
      const wrapper = range.closest('[data-discovery-price]');
      const output = wrapper?.querySelector('[data-discovery-price-output]');
      const hiddenInput = wrapper?.querySelector('[data-discovery-price-input]');
      range.addEventListener('input', () => {
        if (output) output.textContent = range.value;
        if (hiddenInput) hiddenInput.value = Number(range.value) >= Number(range.max) ? '' : range.value;
        if (pending) pending.hidden = false;
      });
    });

    const announcer = root.querySelector('[data-discovery-announcer]');
    const count = root.querySelector('[data-discovery-results-count]')?.textContent?.trim();
    if (announcer && count) announcer.textContent = `${count} products shown.`;
    root.dataset.discoveryReady = 'true';
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-electro-discovery]').forEach(initDiscovery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
